import {Layout} from '../../../layout'

export const FloatingPageHeader = ({className, left, right, ...rest}) => {
	return (
		<Layout className={className} horizontal="spaceBetween" padding="16 0 4 0" {...rest}>
			<Layout className="left-page-header">{left}</Layout>
			<Layout className="right-page-header">{right}</Layout>
		</Layout>
	)
}
